import { create } from 'zustand';

import { createDoBoxReplyPanelSlice } from './actions';
import { buildReplyDraftKey } from './handlers';
import { DoBoxReplyPanelStore, ReplyDraft } from './types';
import { DoBoxReplyPanelMode } from '../../enums';

export const useDoBoxReplyPanelStore = create<DoBoxReplyPanelStore>()(
  (set, get, store) => ({
    ...createDoBoxReplyPanelSlice(set, get, store),
  }),
);

export const useDoBoxReplyPanelMode = (itemId: string): DoBoxReplyPanelMode =>
  useDoBoxReplyPanelStore(
    (state) => state.modeByItemId[itemId] ?? DoBoxReplyPanelMode.OPTIONS,
  );

export const useIsReplyingTo = (itemId: string, messageId: string): boolean =>
  useDoBoxReplyPanelStore(
    (state) =>
      state.activeReply?.itemId === itemId &&
      state.activeReply?.messageId === messageId,
  );

export const useDoBoxReplyDraft = (
  itemId: string,
  messageId: string,
): ReplyDraft | undefined =>
  useDoBoxReplyPanelStore(
    (state) => state.draftsByKey[buildReplyDraftKey(itemId, messageId)],
  );

export const useDoBoxReplyPanelLastSent = () =>
  useDoBoxReplyPanelStore((state) => state.lastSent);
